export default "/images/framework/ChallengeAgainCht.8a60f36a.svg?8a60f36a";